module.exports = __webpack_public_path__ + "img/syllable-struct-wiki.43fcc62e.svg";